import * as THREE from 'three'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { useVerandaSelector } from '../../../..'
import { Helper } from '../../../../classes/helper'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { SideTie } from '../window/side/tie/SideTie'
import { Box, Merged } from '@react-three/drei'

const Shutters = (): JSX.Element => {
  const shutterFrameSurcharge = 0.02
  const { spaceBetween, spaceBetweenY, type, sidwallTyp, shutter } =
    useSidewall()
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)

  const rightSide = type === Keys.Seitenwände.Values.SeitenwandRechts.key
  const spacing = 0.001
  const shutterHeight = shutter.height
  const logWidth = sidwallTyp.log.width
  const slidingShutters = shutter.sliding
  const slidingLogHeight = logWidth + shutterFrameSurcharge
  const spaceY = spaceBetweenY

  const count = Math.floor(spaceY / (shutterHeight + spacing / 2))
  const idealHeight = spaceY / count + spacing / 2
  const maxCount = shutterHeight <= idealHeight ? count + 1 : count
  const finalHeight = spaceY / maxCount + spacing / 2

  const numberOfShutter = shutter.count
  const spacingBetweenShutter = logWidth * 2

  const shutterWidth =
    (spaceBetween -
      ((spacingBetweenShutter + sidwallTyp.log.width) * numberOfShutter) / 2) /
    numberOfShutter

  const shutterDepth = shutter.depth

  const mesh = new THREE.Mesh()

  return (
    <group
      name="shutters"
      position={[
        0,
        0,
        (type === Keys.Seitenwände.Values.SeitenwandRechts.key
          ? (shutterWidth + (sidwallTyp.log.width * numberOfShutter) / 2) / 2
          : -(
              shutterWidth +
              (sidwallTyp.log.width * (numberOfShutter - 1)) / 2
            ) / 2) *
          (numberOfShutter - 1),
      ]}
      rotation={[0, Helper.convertAngleToRadiant(rightSide ? -90 : 90), 0]}
    >
      {[...Array(numberOfShutter)].map((_, i) => (
        <group
          key={`ShutterLog${i}`}
          position={[
            -shutterWidth / 2 - (shutterWidth + spacingBetweenShutter) * i,
            spaceY / 2,
            finalHeight * (slidingShutters ? i : 0),
          ]}
        >
          {[...Array(2)].map((_, index) => (
            <SideTie
              key={`ShutterLogSide${index}${i}`}
              size={[
                sidwallTyp.log.width,
                spaceY + sidwallTyp.log.width + shutterFrameSurcharge,
                sidwallTyp.log.depth,
              ]}
              rotation={[0, 0, 0]}
              position={[
                (shutterWidth + sidwallTyp.log.width) * index -
                  sidwallTyp.log.width / 2,
                0,
                0,
              ]}
            />
          ))}
          {[...Array(2)].map((_, o) => (
            <SideTie
              key={`ShutterLogSideTopBottom${o}${i}`}
              size={[
                shutterWidth,
                sidwallTyp.log.width + shutterFrameSurcharge,
                sidwallTyp.log.depth,
              ]}
              rotation={[0, 0, 0]}
              position={[
                shutterWidth / 2,
                -spaceY / 2 + spaceY * o + sidwallTyp.log.width * 2,
                0,
              ]}
            />
          ))}
        </group>
      ))}

      {slidingShutters && (
        <SideTie
          key={`ShutterSlideLogTop${numberOfShutter}`}
          size={[
            shutterWidth * numberOfShutter,
            sidwallTyp.log.width + shutterFrameSurcharge,
            shutterHeight * numberOfShutter,
          ]}
          rotation={[0, 0, 0]}
          position={[
            -(shutterWidth * (numberOfShutter - 1)) / 2,
            spaceBetweenY,
            (shutterHeight * (numberOfShutter - 1)) / 2,
          ]}
        />
      )}
      {mesh && (
        <Merged meshes={[mesh]} castShadow receiveShadow>
          {() =>
            [...Array(numberOfShutter)].map((_, i) => (
              <mesh
                position={[
                  -(shutterWidth + spacingBetweenShutter) * i,
                  shutterHeight / 2,
                  finalHeight * (slidingShutters ? i : 0),
                ]}
                key={`ShutterGroup${i}`}
              >
                {[...Array(maxCount)].map((_, i) => (
                  <Box
                    key={`Shutter${i}`}
                    args={[shutterWidth, finalHeight, shutterDepth]}
                    position={[
                      0,
                      i * (finalHeight + spacing) +
                        sidwallTyp.log.width -
                        finalHeight / 2,
                      0,
                    ]}
                    rotation={[
                      !shadingMode ? Helper.convertAngleToRadiant(90) : 0,
                      0,
                      0,
                    ]}
                    receiveShadow
                    castShadow
                  >
                    <meshStandardMaterial color={shutter.color} />
                  </Box>
                ))}
              </mesh>
            ))
          }
        </Merged>
      )}
    </group>
  )
}

export default Shutters
